import { ColorPickerFormField } from '@/domain/termine/features/CreateTerminKalender/shared/FormFields/ColorPickerFormField';
import { InputFormField } from '@/domain/termine/features/CreateTerminKalender/shared/FormFields/InputFormField';
import { useTranslation } from 'react-i18next';

export function CreateTerminKalenderFormContent() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 px-6">
      <span className="font-normal text-neutrals-700 text-xs md:py-2 xs:py-6">
        {t('domain.termine.sheet.pflichtfelder')}
      </span>
      <div className="flex flex-col flex-1 gap-4">
        <div className="flex flex-col gap-4 flex-1">
          <div className="flex gap-4 items-start">
            <InputFormField />
            <ColorPickerFormField />
          </div>
        </div>
      </div>
    </div>
  );
}
